export const configActionTypes = {
  GET_PENDING: 'config/get/pending',
  GET_FULFILLED: 'config/get/fulfilled',
  GET_REJECTED: 'config/get/rejected',

  CONFIG_USER_GET_PENDING: 'config/user/get/pending',
  CONFIG_USER_GET_FULFILLED: 'config/user/get/fulfilled',
  CONFIG_USER_GET_REJECTED: 'config/user/get/rejected',
} as const;
